export class PostcodeLookup {
	constructor(input) {
		this.input = input;
		this.outcode = "";
        this.noMatch = false;
		this.locations = window.locations;
		this.defaultDetails = window.defaultDetails;
		this.closestLocation = {};

		if (input) {
			this.onInput(input);
		}
	}

	onInput(e) {
		const postcode = e.value.toUpperCase();

		/* tests to see if string is in correct UK style postcode: AL1 1AB, BM1 5YZ etc. */
		function isValidPostcode(p) {
			var postcodeRegEx = /[A-Z]{1,2}[0-9]{1,2} ?[0-9][A-Z]{2}/i;
			return postcodeRegEx.test(p);
		}

		/* formats a VALID postcode nicely: AB120XY -> AB1 0XY */
		function formatPostcode(p) {
			var postcodeRegEx = /(^[A-Z]{1,2}[0-9]{1,2})([0-9][A-Z]{2}$)/i;
			return p.replace(postcodeRegEx, "$1 $2");
		}

		if (isValidPostcode(postcode)) {
			const formatted = formatPostcode(postcode);
			this.outcode = formatted.split(" ")[0];
		} else {
			this.outcode = "";
		}

		if (this.outcode.length) {
			this.search();
		}
	}

	search() {
		this.getClosestLocation();
		// this.setClosestLocation();
	}

	getClosestLocation() {
		const match = this.locations.filter((location) => {
			const postcodes = location.postcodes;
			var hasMatch = postcodes.some((postcode) =>
				new RegExp(this.outcode).test(postcode)
			);
			if (hasMatch) {
				return location;
			}
		});

		if (match && match.length) {
			this.closestLocation = match[0];
		} else {
            this.noMatch = true;
			this.closestLocation = this.getDefaultLocation();
		}
	}

	getDefaultLocation() {
		return this.locations.filter((l) => l.name === "Slough")[0];
	}
}
